import React, { useState } from 'react';
import { Box, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ProfileIcon from '../messaging/ProfileIcon';

const CompanyMembersList = ({ companyUsers, currentUser, isAdmin, stringToColor, onRemoveUser }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleMenuOpen = (event, member) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(member);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const handleRemoveUser = () => {
    if (onRemoveUser && selectedUser) {
      onRemoveUser(selectedUser);
    }
    handleMenuClose();
  };

  // Sort so current user is first
  const sortedCompanyUsers = [...companyUsers].sort((a, b) => {
    if (a.userId === currentUser.userId) return -1;
    if (b.userId === currentUser.userId) return 1;
    return 0;
  });

  return (
    <>
      {sortedCompanyUsers.map((member) => {
        const isCurrentUser = member.userId === currentUser.userId;
        const avatarColor = stringToColor(`${member.firstName} ${member.lastName}`);
        return (
          <Box
            key={member.userId}
            sx={{
              display: 'flex',
              alignItems: 'center',
              py: 2,
              borderBottom: '1px solid #f0f0f0',
              gap: 2,
              opacity: isCurrentUser ? 0.5 : 1,
              pointerEvents: isCurrentUser ? 'none' : 'auto',
              backgroundColor: isCurrentUser ? 'action.selected' : 'inherit',
            }}
          >
            <ProfileIcon
              user={{
                firstName: member.firstName,
                lastName: member.lastName,
                email: member.email,
                type: member.type,
              }}
              size="small"
              sx={{ bgcolor: avatarColor, color: '#fff' }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {member.firstName} {member.lastName}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {member.email}
              </Typography>
            </Box>
            {isAdmin && !isCurrentUser && (
              <>
                <IconButton size="small" sx={{ ml: 1 }} onClick={(e) => handleMenuOpen(e, member)}>
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
        );
      })}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleRemoveUser}>Remove User</MenuItem>
      </Menu>
    </>
  );
};

export default CompanyMembersList; 